function getFaviconFromPageProps(pageProps, defaultUrl) {
    var _a, _b, _c;
    return (_c = (_a = pageProps.favicon) !== null && _a !== void 0 ? _a : (_b = pageProps.layout) === null || _b === void 0 ? void 0 : _b.globalSettings.favicon) !== null && _c !== void 0 ? _c : defaultUrl;
}
export default getFaviconFromPageProps;
//# sourceMappingURL=getFaviconFromPageProps.js.map